const style = (theme) => ({
  root: {
    background: theme.colors[1],
  },
  rootDark: {},
})

export default style
